const styles = {
  container: {
    height: "40px",
    width: "254px",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "CircularStd",
    margin: "0 auto",
  },
  pointer: {
    cursor: "pointer",
  },
  hideOnMobileLandscape: {
    "@media screen and (max-width: 900px)": {
      display: "none",
    },
  },
  currentLabel: {
    height: 18,
    width: "100%",
    color: "#6373A4",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "18px",
    paddingLeft: "5px",
    paddingRight: "5px",
    display: "table-cell",
    verticalAlign: "middle",
  },
  separatorContainer: {
    paddingRight: "6px",
    paddingLeft: "9px",
    "@media (max-width: 1200px)": {
      display: "none",
    },
  },
  separator: {
    display: "inline-block",
    boxSizing: "border-box",
    height: "24px",
    width: "1px",
    border: "0.5px solid #051D39",
    opacity: 0.2,
  },
  arrowSlot: { display: "none" },
  slot1: {
    paddingLeft: "13px",
  },
  currentLabelContainer: {},
  slot3: { paddingRight: 5 },
  slot2: {},
  slotDisplay: { display: "block" },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  iconContainerLeft: {
    justifyContent: "flex-start",
    textAlign: "left",
  },
  iconContainerRight: {
    justifyContent: "flex-end",
    textAlign: "right",
  },
  flex: {
    display: "flex", // Used on the divs wrapping the icons in iconcontainerleft and right
    alignItems: "center",
  },
  // Portrait
  "@media (max-width: 1200px)": {
    container: {
      height: 51,
      maxWidth: 346,
      margin: "0 auto",
      width: "100vw",
      boxShadow: "none",
      borderRadius: 4,
      justifyContent: "space-between",
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      maxWidth: "100%",
    },
    arrowSlot: {
      paddingLeft: "10px",
      display: "block",
    },
    slot1: {},
    slotDisplay: { display: "none" },
    currentLabelContainer: {
      paddingLeft: "8px",
    },
    slot3: {
      marginLeft: "auto",
      paddingRight: 9,
    },
    currentLabel: {
      fontSize: "16px !important",
      lineHeight: "20px",
      paddingLeft: "8px",
      marginTop: "-5px",
    },
  },
};

export default styles;
